// extracted by mini-css-extract-plugin
export default {"menu":"_3GNI2___SidebarMenu-module__menu"};